const Span = ({ children }) => {
  return (
    <span style={{ backgroundColor: '#fff2cc', color: '#235078' }}>
      {children}
    </span>
  )
}

export default Span
